import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MailOpen, Mail } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function AdminMessages() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/contact").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.put(`/contact/${id}/read`); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try { await api.delete(`/contact/${id}`); toast.success("Deleted."); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <header className="mb-8">
        <p className="label-xs">Inbox</p>
        <h1 className="mt-2 font-heading font-black text-4xl tracking-tighter">Messages</h1>
      </header>

      {items.length === 0 ? (
        <div className="border border-dashed border-border rounded-sm p-10 text-center text-muted-foreground">
          No messages yet.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <article key={m.id} className={`border ${m.read ? "border-border" : "border-foreground"} rounded-sm p-5`}>
              <div className="flex items-baseline justify-between gap-4">
                <div>
                  <p className="font-heading font-bold text-lg">{m.name} <span className="text-muted-foreground font-mono font-normal text-sm">&lt;{m.email}&gt;</span></p>
                  {m.subject && <p className="text-sm text-muted-foreground mt-1">{m.subject}</p>}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-muted-foreground">
                    {new Date(m.created_at).toLocaleString()}
                  </span>
                  {!m.read && (
                    <Button size="icon" variant="ghost" onClick={() => markRead(m.id)} title="Mark as read">
                      <MailOpen className="h-4 w-4" />
                    </Button>
                  )}
                  {m.read && <Mail className="h-4 w-4 text-muted-foreground" />}
                  <Button size="icon" variant="ghost" onClick={() => remove(m.id)}><Trash2 className="h-4 w-4" /></Button>
                </div>
              </div>
              <p className="mt-4 text-sm whitespace-pre-wrap leading-relaxed">{m.message}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
